export enum ENDPOINT_NAMES {
  AUTH = "auth",
}
